export default {
  steps: [
    {
      title: 'Informações básicas',
      icon: 'FileTextIcon',
      completed: false,
      current: true,
      path: 'step-basic-info',
      order: 0,
    },
    {
      title: 'Endereço',
      icon: 'PhoneIcon',
      completed: false,
      current: false,
      path: 'step-address',
      order: 1,
    },
    {
      title: 'Formação',
      icon: 'BookIcon',
      completed: false,
      current: false,
      path: 'step-formation',
      order: 2,
    },
    {
      title: 'Experiências',
      icon: 'AwardIcon',
      completed: false,
      current: false,
      path: 'step-experiences',
      order: 3,
    },
    {
      title: 'Idiomas',
      icon: 'MessageSquareIcon',
      completed: false,
      current: false,
      path: 'step-languages',
      order: 4,
    },
    {
      title: 'Habilidades',
      icon: 'StarIcon',
      completed: false,
      current: false,
      path: 'step-skills',
      order: 5,
    },
    {
      title: 'Perguntas Complementares',
      icon: 'LampIcon',
      completed: false,
      current: false,
      path: 'step-complementary-questions',
      order: 6,
    },
    {
      title: "Revisão",
      icon: "ThumbsUpIcon",
      completed: false,
      current: false,
      path: "step-revision",
      order: 7,
    }
  ],
  currentStep: 0,
  secondStep: 0,
  step: {
    progress: 10
  },
  basicFormSubmit: { trigger: false, goTo: undefined },
}
